import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'

import { createDataModelEffects } from './data-model.effects'

import { DataModelApiService } from '../../api/data-model.api'
import { UiFlowDataModelActions } from '../actions/ui-flow-data-model.actions'

const uiFlowDataModelBasicEffects = createDataModelEffects(
  ApplicationResourceType.UiFlow,
  {
    load: UiFlowDataModelActions.loadEntities,
    loadSuccess: UiFlowDataModelActions.loadEntitiesSuccess,
    loadFailure: UiFlowDataModelActions.loadEntitiesFailure,
    add: UiFlowDataModelActions.addEntity,
    addSuccess: UiFlowDataModelActions.addEntitySuccess,
    addFailure: UiFlowDataModelActions.addEntityFailure,
    edit: UiFlowDataModelActions.editEntity,
    editSuccess: UiFlowDataModelActions.editEntitySuccess,
    editFailure: UiFlowDataModelActions.editEntityFailure,
    addAttribute: UiFlowDataModelActions.addAttribute,
    addAttributeSuccess: UiFlowDataModelActions.addAttributeSuccess,
    addAttributeFailure: UiFlowDataModelActions.addAttributeFailure,
    editAttribute: UiFlowDataModelActions.editAttribute,
    editAttributeSuccess: UiFlowDataModelActions.editAttributeSuccess,
    editAttributeFailure: UiFlowDataModelActions.editAttributeFailure,
    requestDeleteEntity: UiFlowDataModelActions.deleteEntityRequested,
    deleteEntity: UiFlowDataModelActions.deleteEntity,
    deleteEntitySuccess: UiFlowDataModelActions.deleteEntitySuccess,
    deleteEntityFailure: UiFlowDataModelActions.deleteEntityFailure,
    requestDeleteAttribute: UiFlowDataModelActions.deleteAttributeRequested,
    deleteAttribute: UiFlowDataModelActions.deleteAttribute,
    deleteAttributeSuccess: UiFlowDataModelActions.deleteAttributeSuccess,
    deleteAttributeFailure: UiFlowDataModelActions.deleteAttributeFailure,
    resetErrors: UiFlowDataModelActions.resetErrors,
    resetErrorsSuccess: UiFlowDataModelActions.resetErrorsSuccess,
    updateAttributeValidators: UiFlowDataModelActions.updateAttributeValidators,
    updateAttributeValidatorsSuccess: UiFlowDataModelActions.updateAttributeValidatorsSuccess,
    updateAttributeValidatorsFailure: UiFlowDataModelActions.updateAttributeValidatorsFailure,
  },
  DataModelApiService
)

export const uiFlowLoadEntities$ = uiFlowDataModelBasicEffects.loadEntities$
export const uiFlowAddEntity$ = uiFlowDataModelBasicEffects.addEntity$
export const uiFlowEditEntity$ = uiFlowDataModelBasicEffects.editEntity$
export const uiFlowAddAttribute$ = uiFlowDataModelBasicEffects.addAttribute$
export const uiFlowEditAttribute$ = uiFlowDataModelBasicEffects.editAttribute$
export const uiFlowSetNewEntityAsAttribute$ = uiFlowDataModelBasicEffects.setNewEntityAsAttribute$
export const uiFlowStartDeleteEntity$ = uiFlowDataModelBasicEffects.startDeleteEntity$
export const uiFlowDeleteEntity$ = uiFlowDataModelBasicEffects.deleteEntity$
export const uiFlowStartDeleteAttribute$ = uiFlowDataModelBasicEffects.startDeleteAttribute$
export const uiFlowDeleteAttribute$ = uiFlowDataModelBasicEffects.deleteAttribute$
export const uiFlowResetErrors$ = uiFlowDataModelBasicEffects.resetErrors$
export const uiFlowUpdateAttributeValidators$ =
  uiFlowDataModelBasicEffects.updateAttributeValidators$
